import { Icon } from '@chakra-ui/react';
import { LuRotateCcw as ResetIcon } from 'react-icons/lu';

import { Button } from '@/components/v4';
import {
    resetButtonStyles,
    visitResetBtnStyles,
} from 'pages/organisations/partners/edit/constants';

const ResetButton = ({ onReset }) => (
    <Button
        sx={resetButtonStyles}
        onClick={(e) => {
            e.stopPropagation();
            onReset();
        }}
        position="absolute"
        right={5}
        top={4}
        zIndex={20}
        borderRadius="full"
        border="1px solid"
        borderColor="gray.200"
        bg="white"
        h="auto"
        minW="auto"
        p={1}
        fontSize="10px"
        fontWeight="bold"
        textTransform="uppercase"
        letterSpacing="tighter"
        color="gray.500"
        shadow="sm"
        transition="all 0.2s"
        marginTop="0!important"
        leftIcon={<Icon as={ResetIcon} boxSize="14px" />}
        _hover={visitResetBtnStyles}
        _active={visitResetBtnStyles}
        title="Reset to default">
        Reset
    </Button>
);

export default ResetButton;
